import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const CampaignPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  routes: [
    {
      path: routesUrl.campaignCreation,
      component: React.lazy(() => import('app/main/apps/communicationCampaign/page/CampaignCreationPage')),
    },
    {
      path: routesUrl.campaignTemplateCreation,
      component: React.lazy(() => import('app/main/apps/communicationCampaign/page/CampaignCreationPage')),
    },
    {
      path: routesUrl.campaignEdition,
      component: React.lazy(() => import('app/main/apps/communicationCampaign/page/CampaignEditionPage')),
    },
    {
      path: routesUrl.campaignHistory,
      component: React.lazy(() => import('app/main/apps/communicationCampaign/page/CampaignHistoryPage')),
    },
    {
      path: routesUrl.campaignDetail,
      component: React.lazy(() => import('app/main/apps/communicationCampaign/page/CampaignDetailPage')),
    },
  ],
};

export default CampaignPageConfig;
